import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "~/styles/theme"

export const Dropper = styled.div`
    width: 100%;
    background: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 17px 20px;

    .separator {
        font-weight: bold;
        font-size: 48px;
        text-align: center;
        color: #ddd;
    }

    .drop-files {
        display: flex;
        font-size: 18px;
        color: #2e2e2e;

        p {
            margin: 0;
            margin-left: 8px;
        }
    }
`;

export const UploadButtonLine = styled.div`
    background-color: #e5e5f7;
    opacity: 0.8;
    background: repeating-linear-gradient(-45deg, #ebebeb, #ebebeb 5px, #dcdcdc 5px, #dcdcdc 25px);
    text-align: right;
    margin: 10px 0;
    padding: 5px;
`;

export const dropzoneStyle: CSSProperties = {
    border: "1px dashed #bdbdbd",
    background: "#fdfdfd",
    position: "relative",
    minHeight: "200px"
};

export const DropzoneButton = styled.button`
    font-size: 12px;
    cursor: pointer;
    background: #4b9afe;
    text-transform: uppercase;
    color: #fff;
    font-weight: bold;
    border: 1px solid #4b9afe;
    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.37) inset, 1px 0 1px rgba(255, 255, 255, 0.07) inset,
        0 1px 0 rgba(0, 0, 0, 0.36), 0 -2px 12px rgba(0, 0, 0, 0.08) inset;
    padding: 10px 40px;
    margin: 15px 20px;
    letter-spacing: 0.86px;

    &:focus {
        outline: none;
    }
`;

export const DropzoneLabel = styled.span`
    text-transform: uppercase;
    text-align: center;
    display: block;
    font-size: 12px;
    letter-spacing: 0.86px;
    font-weight: bold;
    color: #ff7e00;
    line-height: 14px;
`;

type UploadingItemBgColorKeys = "pending" | "success" | "error";
const UploadingItemBgColor: Record<UploadingItemBgColorKeys, string> = {
    pending: "#f6f6f6",
    success: "#d8ffd4",
    error: "#f5d7d7"
};

type UploadingItemProps = { variant: UploadingItemBgColorKeys };

export const UploadingItem = styled.div<UploadingItemProps>`
    margin: 10px 20px;
    padding: 15px 9px;
    line-height: 15px;
    font-size: 16px;
    color: #424242;
    background-color: ${props => UploadingItemBgColor[props.variant]};
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
`;

export const MainText = styled.span`
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
`;

export const ComplementaryText = styled.span`
    font-size: 12px;
    font-weight: 400;
`;

export const ProgressBar = styled.div`
    height: 2px;
    overflow: hidden;
    background: transparent;
    border-radius: 5px;
    width: 100%;
    box-shadow: none;
`;

export const ProgressBarIndicator = styled.div`
    background: ${theme.color.primary.background};
    height: 10px;
`;

export const CancelButton = styled.button`
    background-color: #f5d7d7;
    border-color: #e6c8c8;
    vertical-align: middle;
    cursor: pointer;
    box-shadow: 0 1px 1px rgb(255 255 255 / 37%) inset, 1px 0 1px rgb(255 255 255 / 7%) inset, 0 1px 0 rgb(0 0 0 / 36%),
        0 -2px 12px rgb(0 0 0 / 8%) inset;
    padding: 3px 4px;
    border: 1px solid #ccc;
    border-radius: 2px;

    &:hover {
        background-color: #ffe1e1;
    }
`;

export const TryAgainButton = styled.button`
    background-color: #d8ffd4;
    border-color: #d2ddc7;
    vertical-align: middle;
    cursor: pointer;
    box-shadow: 0 1px 1px rgb(255 255 255 / 37%) inset, 1px 0 1px rgb(255 255 255 / 7%) inset, 0 1px 0 rgb(0 0 0 / 36%),
        0 -2px 12px rgb(0 0 0 / 8%) inset;
    padding: 3px 4px;
    border: 1px solid #ccc;
    border-radius: 2px;

    &:hover {
        background-color: #f7ffec;
    }
`;
